import { features } from '../data/landingPageData';
import Icon from './Icon';
import PhoneMockup from './PhoneMockup';
import './FeaturesSection.css';

function FeaturesSection() {
  return (
    <section className="features-section" id="features">
      <h2>Key features</h2>
      <div className="feature-grid">
        {features.map((feature) => (
          <FeatureCard feature={feature} key={feature.title} />
        ))}
      </div>
    </section>
  );
}

function FeatureCard({ feature }) {
  return (
    <article className={`feature-card feature-${feature.accent}`}>
      <div className="feature-copy">
        <Icon name={feature.icon} />
        <h3>{feature.title}</h3>
        <p>{feature.text}</p>
      </div>
      <PhoneMockup variant={feature.phone} />
    </article>
  );
}

export default FeaturesSection;
